import {readNativeRenderRequest} from './native-render-job';
import type {NativeWorkScope} from './native-envelope';

export type NativeAiSceneRequest={
 requestId:string;scope:NativeWorkScope;expectedRevision:string;
 mode:'generate';prompt:string;maxDurationSeconds:number;
};
export type NativeAiSceneLookup=Pick<NativeAiSceneRequest,'requestId'|'scope'>;
export function nativeAiSceneFrameBudget(maxDurationSeconds:number,fps:number){
 const frames=maxDurationSeconds*fps,budget=Math.floor(frames+1e-9);
 if(!Number.isFinite(fps)||fps<=0||!Number.isFinite(maxDurationSeconds)||maxDurationSeconds<=0||!Number.isSafeInteger(budget)||budget<1)throw Error('AI 씬은 한 프레임 이상의 길이로 요청해 주세요.');
 return budget;
}
export function readNativeAiSceneLookup(raw:unknown):NativeAiSceneLookup{
 if(!raw||typeof raw!=='object'||Array.isArray(raw))throw Error('AI 씬 조회 정보를 확인해 주세요.');
 const value=raw as Record<string,unknown>;
 if(Object.keys(value).some(key=>!['requestId','scope'].includes(key)))throw Error('AI 씬 조회 범위를 확인해 주세요.');
 // Reuse identifier/scope validation only; lookup deliberately does not require a saved revision.
 const base=readNativeRenderRequest({requestId:value.requestId,scope:value.scope,expectedRevision:'1970-01-01T00:00:00.000Z'});
 if(Object.keys(value.scope as object).some(key=>!['projectId','workId','surface'].includes(key)))throw Error('AI 씬 조회 범위를 확인해 주세요.');
 return {requestId:base.requestId,scope:base.scope};
}
/** Native-scene creation only. Code execution and modify actions require separate contracts. */
export function readNativeAiSceneRequest(raw:unknown):NativeAiSceneRequest{
 if(!raw||typeof raw!=='object'||Array.isArray(raw))throw Error('AI 씬 요청 정보를 확인해 주세요.');
 const value=raw as Record<string,unknown>;
 if(Object.keys(value).some(key=>!['requestId','scope','expectedRevision','mode','prompt','maxDurationSeconds'].includes(key))||value.mode!=='generate'||typeof value.prompt!=='string'||!value.prompt.trim()||value.prompt.length>16000)throw Error('AI 씬 생성 요청의 내용과 범위를 확인해 주세요.');
 const base=readNativeRenderRequest({requestId:value.requestId,scope:value.scope,expectedRevision:value.expectedRevision});
 if(Object.keys(value.scope as object).some(key=>!['projectId','workId','surface'].includes(key)))throw Error('AI 씬 작업 범위에 알 수 없는 정보가 있습니다.');
 const maxDurationSeconds=value.maxDurationSeconds??15;
 if(typeof maxDurationSeconds!=='number'||!Number.isFinite(maxDurationSeconds)||maxDurationSeconds<=0||maxDurationSeconds>15)throw Error('AI 씬 길이는 15초 이내로 지정해 주세요.');
 return {requestId:base.requestId,scope:base.scope,expectedRevision:base.expectedRevision,mode:'generate',prompt:value.prompt.trim(),maxDurationSeconds};
}
